// extracted by mini-css-extract-plugin
module.exports = {"search":"search--SiteSearch-components__34iiA"};